import './plugins/element-ui';


import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './axios';
import './utils/filter.js'

import YorkbbsImage from './components/image.vue';
Vue.component('YorkbbsImage', YorkbbsImage);
import md5 from 'js-md5';

Vue.prototype.$md5 = md5;
import 'swiper/css/swiper.min.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);

import store from './store.js';
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
